import axios from 'axios'
import { Message, MessageBox } from 'element-ui';
import token from '../common/utils/token'
import { ajaxError } from './utils/ajaxError';
import eslint from './utils/eslint';
let base = ''

export default {
    ajax() {
        let params = [];
        params.push.apply(params, arguments);
        params.splice(0, 1);
        let url = `${base}${arguments[0]}`;

        return axios.post(url, params).then(res => {
            let data = res.data;
            if (!data.success) {
                if (data.msg) {
                    if(!(data.msg.indexOf("NO_SHOW_MSG_")===0)){
                      errMessage($lang(data.msg));
                    }
                    throw data.msg
                }
            }
            return data;
        }, (err, status) => {
            ajaxError(err, status, url)
        })
    },
    ajaxGet() {
        var params = [];
        params.push.apply(params, arguments);
        params.splice(0, 1);
        let url = `${base}${arguments[0]}`;
        return axios.post(url, params).then(res => {
            let data = res.data;
            if (!data.success) {
                if (data.msg) {
                    errMessage(data.msg);
                    throw data.msg
                }
            }
            return data;
        }, (err, status) => {
            ajaxError(err, status)
        })
    },
    downloadAttachment(url, params, isOpen, json) {
        isOpen = isOpen == undefined ? false : isOpen;
        //compress=compress==undefined?true:compress;
        let arr = [];
        for (let p in params) {
            arr.push(p + "=" + params[p]);
        }
        // arr.push("xToken="+token.getToken());
        //if(!compress)
        arr.push("$compress=true");

        url = url + "?" + arr.join("&");

        if (isOpen) {
            window.open(url);
        } else {
            var form = $("#download-form");
            form.attr("action", url);
            if (json) {
                $("#download-form-json").val(json);
            } else {
                $("#download-form-json").val("");
            }
            form.submit();
        }
    },

    /**
     * @async
     * @param {Object} param
     * @param {string} param.url download url
     * @param {string} param.method download method, default as POST
     * @param {Object} param.params download params
     * @param {string} param.enctype default as application/x-www-form-urlencoded
     * @return {Promise<Object>} the response from server
     */
    downloadAttachment2({ url, params = {}, enctype = 'application/x-www-form-urlencoded', method = 'POST' }) {
        return new Promise((resolve, reject) => {
                    const frameId = (Math.random() * 6 + 10).toString(16).replace('.', '');
                    $(`
        <form action="${url}" enctype="${enctype}" method = "${method}">
          ${Object.keys(params).map(name => {
            if (typeof params[name] !== 'undefined') {
              return `<textarea name=${name}>${params[name]}</textarea>`;
            } else {
              return '';
            }
          }).join('')}
        </form>
      `)
      .appendTo(
        $(`<iframe id="${frameId}" style="display:none"></iframe>`)
        .appendTo(document.body)
        .one('load', function() {
          const iframe = this;
          if (iframe.contentDocument) {
            const text = iframe.contentDocument.body.innerText;
            try {
              const response = JSON.parse(text);
              resolve(response);
            } catch(err) {
              // the response is not a valid JSON format
              resolve({
                success: false,
                msg: text
              });
            }
          }
          $(iframe).remove();
        })
        .one('error', function(e) {
          resolve({
            success: false,
            msg: e.toString()
          });
          const iframe = this;
          $(iframe).remove();
        })
        .get(0)
        .contentDocument
        .body
      ).submit();

      setTimeout(function(frameId) {
        $(`#${frameId}`).remove();
      }.bind(null, frameId), 60000);
    });
  },

  applyCover : function(o, c){  //o中存在的覆盖，不存在忽略
    if(o && c){
      for(let oo in o){
        for(let cc in c){
          if(oo==cc){
            o[oo] = c[cc];
          }
        }
      }
    }
    return o;
  },
  isDefined : function(v){
    return typeof v !== 'undefined';
  },
  apply :function(o, c, defaults){
    if(defaults){
      this.apply(o, defaults);
    }
    if(o && c && typeof c == 'object'){
      for(var p in c){
        o[p] = c[p];
      }
    }
    return o;
  },
  applyIf : function(o, c){
    if(o){
      for(var p in c){
        if(!this.isDefined(o[p])){
          o[p] = c[p];
        }
      }
    }
    return o;
  },
  eslint,
  esLintMsg(code, options){
    return eslint(code, options).then(msg=>{
      if (msg.length > 0) {
        const html = `
            <table class="table table-bordered table-striped">
              <thead>
                <tr>
                  <th>行</th>
                  <th>列</th>
                  <th>错误</th>
                </tr>
              </thead>
              <tbody>
                ${msg.map(({column, line, message}) => {
                  return `
                    <tr>
                      <td>${line}</td>
                      <td>${column}</td>
                      <td>${message}</td>
                    </tr>
                  `
                }).join('')}
                </tbody>
              </table>
              `;
        MessageBox.alert(html,options.title || "语法错误",{
          dangerouslyUseHTMLString: true
        });
      }
      return msg.length==0
    })
  }
}


const downloadUrl = url => {
  let iframe = document.createElement('iframe')
  iframe.style.display = 'none'
  iframe.src = url

  let onload=function(){

  }
  iframe.onload = onload;
  //绑定iframe的onload事件
  /*if(onload && Object.prototype.toString.call(onload) === '[object Function]'){
    if(iframe.attachEvent){
      iframe.attachEvent('onload', onload);
    }else if(iframe.addEventListener){
      iframe.addEventListener('onload', onload);
    }else{
      iframe.onload = onload;
    }
  }*/

/*  iframe.onload = function () {
    console.log('----------------')
    document.body.removeChild(iframe)
  }*/
  document.body.appendChild(iframe)
}
if(!window.localStorage.getItem("$customSessionId"))
  window.localStorage.setItem("$customSessionId",$uuid());

axios.interceptors.request.use(function(config){
  // config.headers.Authorization='Bearer ' + token.getToken();
  return config;
},function(error){
  return Promise.reject(error);
});


$.ajaxSetup({
  type: "POST",
  beforeSend: function(xhr)
  {
    // xhr.setRequestHeader('Authorization', 'Bearer ' + token.getToken());
  },
  complete: function(xhr)
  {

  },
  statusCode: {
    401: function(a,err)
    {
      ajaxError(err,'401')
    }
  }
});


export function errMessage(message){
  PF.message("error",message);
  //Message.error({message:message,showClose: true});
}

export const security = _=>({
  type: 'http',
  scheme: 'bearer',
  token: token.getToken()
});



// WEBPACK FOOTER //
// ./src/common/util.js